import { render, staticRenderFns } from "./LiveSportsTable.vue?vue&type=template&id=720fc7c7&scoped=true"
import script from "./LiveSportsTable.vue?vue&type=script&lang=js"
export * from "./LiveSportsTable.vue?vue&type=script&lang=js"
import style0 from "./LiveSportsTable.vue?vue&type=style&index=0&id=720fc7c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720fc7c7",
  null
  
)

export default component.exports